import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import 'react-dropdown-tree-select/dist/styles.css'

class Config extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serverFreeSpace: 0,
            total_sale: 0,
            total_used: 0
        }
    }
    componentDidMount() {
        this.getStorage();

    }
    getStorage = () => {
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        let _this = this;
        axios.post(`${SERVER_IP}/storageDetails`, {}, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error) {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getStorage();
                        }
                    })
                } else {
                    _this.setState({
                        serverFreeSpace: response.data.serverFreeSpace,
                        total_sale: response.data.total_sale,
                        total_used: response.data.total_used
                    })
                }
            })
            .catch(function (error) {
                // swal("Something Went Wrong,Please Retry")
            });
    }
    render() {

        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">

                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    {/* <li class="breadcrumb-item active" onClick={() => window.location.href = "/create/listuser"}>List Users</li> */}
                                </ol>
                            </div>
                        </div>
                    </div>

                    <div className="xp-contentbar mt-5">
                        <div className="row">
                            <div className="">
                                <div className="card m-b-30">
                                    <div className="card-header bg-primary">
                                        <h5 className="card-title text-white">Configuration</h5>
                                    </div>
                                    <div className="card-body">
                                        <div class="xp-social-profile-middle text-center">
                                            <div class="row">
                                                <div class="col-12">

                                                    <div class="xp-social-profile-title">
                                                        <h5 class="my-1 text-black">System Configuration</h5>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <ul className="profile-list">
                                            <li><big><label className="text-success">{this.state.serverFreeSpace} GB</label> </big> <p>Total Server Free Storage</p></li>
                                            <li><big><label className="text-success" >{this.state.total_sale} GB</label></big> <p>Total Corporate Occupied</p></li>
                                            <li><big><label className="text-danger">{this.state.total_used} GB</label></big> <p>Total Corporate Usage</p></li>
                                            <li><big><label className="text-danger">{this.state.serverFreeSpace - this.state.total_sale} GB</label></big> <p>Total available for Sale</p></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
 

        )
    }
}
export default Config
